import Immutable from 'immutable';
import { defaultCommunicationObject, updateCommunicationObject } from '~client/reducers/shared';
import { paymentActionTypes } from '~constants/actionTypes';

export const defaultState = Immutable.fromJS({
  properties: {
    communication: defaultCommunicationObject,
    totalCount: 0,
    payload: [],
  },
  paymentProcess: {
    method: null,
    connectedAccountId: null,
    communication: defaultCommunicationObject,
  },
  stripe: {
    communication: defaultCommunicationObject,
    clientId: null,
  },
  selectedPropertyIds: [],
  termsAndConditions: [],
  deposits: [],
  firstInstalment: {},
  firstInstalmentSkiped: false,
  paymentsEnabled: false,
  paymentEdit: false,
  longtail: {
    paymentPlan: null,
    paymentPlans: [],
    getListCommunication: defaultCommunicationObject,
    orderInstalment: null,
  },
  communication: {
    createInstalmentStatus: defaultCommunicationObject,
    updateInstalmentStatus: defaultCommunicationObject,
  },
});

const formatProperties = (properties, filterPaymentProcess = false) => {
  if (!filterPaymentProcess) {
    return properties;
  }

  return properties.filter(property => property.node.paymentProcess);
};

const getDeposits = payload => {
  const filteredDeposits = payload.filter(deposit => !deposit.node.firstInstalment);
  return filteredDeposits.map(item => item.node);
};

const getFirstInstalment = payload => {
  const filteredInstalment = payload.find(deposit => deposit.node.firstInstalment);
  return filteredInstalment ? filteredInstalment.node : {};
};

const paymentReducer = (state = defaultState, action) => {
  switch (action.type) {
    case paymentActionTypes.SET_LIST: {
      const nextState = state.deleteIn(['properties', 'payload']);
      return nextState.mergeDeep({
        properties: {
          payload: formatProperties(
            action.payload.viewer.company.properties.edges,
            action.filterPaymentProcess,
          ),
          totalCount: action.payload.viewer.company.properties.totalCount,
        },
      });
    }

    case paymentActionTypes.SET_SETUP:
      return state.mergeDeep({
        selectedPropertyIds: [action.propertyId],
        paymentProcess: action.paymentProcess,
        deposits: getDeposits(action.deposits),
        firstInstalment: getFirstInstalment(action.deposits),
        firstInstalmentSkiped: action.termsAndConditions.length > 0,
        termsAndConditions: action.termsAndConditions.map(terms => terms.node),
        paymentsEnabled: action.paymentsEnabled,
        paymentEdit: true,
      });

    case paymentActionTypes.SET_CONNECTED_ACCOUNT_ID:
      return state.mergeDeep({
        paymentProcess: {
          connectedAccountId: action.connectedAccountId,
        },
      });

    case paymentActionTypes.UPDATE_PAYMENT_DEPOSIT_RULES: {
      return state
        .setIn(['deposits'], action.paymentDepositRules)
        .setIn(['paymentsEnabled'], false);
    }

    case paymentActionTypes.UPDATE_PAYMENT_FIRST_INSTALMENT:
      return state.setIn(['firstInstalment'], action.payload).setIn(['paymentsEnabled'], false);

    case paymentActionTypes.SKIP_PAYMENT_FIRST_INSTALMENT:
      return state.setIn(['firstInstalmentSkiped'], true);

    case paymentActionTypes.SET_SELECTED_PROPERTY_IDS: {
      return state.mergeDeep({
        selectedPropertyIds: action.selectedPropertiesIds,
        stripe: {
          clientId: null,
        },
      });
    }

    case paymentActionTypes.UPDATE_TERMS_AND_CONDITIONS: {
      return state
        .setIn(['termsAndConditions'], action.termsAndConditions)
        .setIn(['paymentsEnabled'], false);
    }

    case paymentActionTypes.UPDATE_PAYMENT_PROCESS:
      return state.mergeDeep({
        paymentProcess: {
          method: action.method,
        },
        paymentsEnabled: false,
      });

    case paymentActionTypes.UPDATE_PAYMENT_ENABLED:
      return state.mergeDeep({
        paymentsEnabled: action.paymentsEnabled,
      });

    case paymentActionTypes.RESET_PAYMENT:
      return defaultState;

    case paymentActionTypes.GET_LIST_CS:
      return state.mergeDeep({
        properties: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case paymentActionTypes.CREATE_CONNECTED_ACCOUNT_CS:
      return state.mergeDeep({
        paymentProcess: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case paymentActionTypes.SET_STRIPE_CLIENT_ID:
      return state.mergeDeep({
        stripe: {
          clientId: action.clientId,
        },
      });

    case paymentActionTypes.GET_STRIPE_CLIENT_ID_CS:
      return state.mergeDeep({
        stripe: {
          communication: updateCommunicationObject(action.status, action.error),
        },
      });

    case paymentActionTypes.GET_LONGTAIL_PAYMENT_PLANS_CS:
      return state.mergeDeep({
        longtail: {
          getListCommunication: updateCommunicationObject(action.status, action.error),
        },
      });

    case paymentActionTypes.CREATE_LONG_TAIL_INSTALMENT_PLAN_CS: {
      return state.mergeDeep({
        communication: {
          createInstalmentStatus: updateCommunicationObject(action.status, action.error),
        },
      });
    }

    case paymentActionTypes.UPDATE_LONG_TAIL_INSTALMENT_PLAN_CS: {
      return state.mergeDeep({
        communication: {
          updateInstalmentStatus: updateCommunicationObject(action.status, action.error),
        },
      });
    }

    case paymentActionTypes.SET_LONG_TAIL_PAYMENT_PLAN:
      return state.setIn(['longtail', 'paymentPlan'], action.payload);

    case paymentActionTypes.RESET_LONG_TAIL_PAYMENT_PLAN:
      return state.setIn(['longtail', 'paymentPlan'], null);

    case paymentActionTypes.SET_LONGTAIL_PAYMENT_PLANS:
      return state.setIn(['longtail', 'paymentPlans'], action.payload);

    default:
      return state;
  }
};

export default paymentReducer;
